import { Injectable } from '@angular/core';
import { Plugins } from '@capacitor/core';

const { Storage } = Plugins;

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  async setObject(key: string, o: any) {
    await Storage.set({
      key: key,
      value: JSON.stringify(o)
    });
  }

  async getObject(key: string) {
    const result = await Storage.get({ key: key });
    return JSON.parse(result.value);
  }

  async setItem(key: string, value: string) {
    await Storage.set({
      key: key,
      value: value,
    });
  }

  async getItem(key: string) {
    const { value } = await Storage.get({ key: key });
    return value;
  }

  async removeObject(key: string) {
    await Storage.remove({ key: key });
  }

  async clear() {
    await Storage.clear();
  }
}
